import { render, staticRenderFns } from "./EndCard.vue?vue&type=template&id=9887ba52&"
import script from "./EndCard.vue?vue&type=script&lang=ts&"
export * from "./EndCard.vue?vue&type=script&lang=ts&"
import style0 from "./EndCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports